import { useCallback, useEffect, useState } from "react";
import { showToast } from "../../../utils/utils";
import { showToastType } from "../../../utils/constants/appConstants";
import { allInvData } from "../../../locales/en";
import privateAxios from "../../../utils/axiosPrivate";
import { getallQuoteDownloadExcelURL } from "../../../utils/constants/apiEndPoints";
import PropTypes from "prop-types";

const AllInvoiceData = ({ onDownloadComplete }) => {
  const [hasDownloaded, setHasDownloaded] = useState(false);

  const handleInvoiceDownload = useCallback(async () => {
    if (hasDownloaded) return;
    setHasDownloaded(true);

    try {
      const response = await privateAxios.get(getallQuoteDownloadExcelURL, {
        responseType: "arraybuffer"
      });

      let filename = "all_invoice_data.csv";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) filename = match[1];
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      showToast(allInvData.errMsg.item1, showToastType.success);
    } catch {
      showToast(allInvData.errMsg.item2, showToastType.error);
      setHasDownloaded(false);
    } finally {
      if (onDownloadComplete) onDownloadComplete();
    }
  }, [hasDownloaded, onDownloadComplete]);

  useEffect(() => {
    handleInvoiceDownload();
  }, [handleInvoiceDownload]);

  return null;
};
AllInvoiceData.propTypes = {
  onDownloadComplete: PropTypes.func
};

export default AllInvoiceData;
